import device from '../__constants/device';

const $ = jQuery.noConflict();

const parallax = () => {
	// Cache DOM
	const parItem = $('.parallax-item');

	// Bind Events
	if (parItem.length && !device.isPhone() && !device.isTablet()) {
		parItem.parallaxie();
	}
};

export default parallax;
